
/*
 * @Author: panweikang
 * @Date: 2024-01-04 15:23:35
 * @LastEditTime: 2024-07-24 22:53:49
 * @Description:
 */
import './Cheats.scss'
import React, { useEffect, useState } from 'react'
import { Avatar, Image, Button, Toast, ImageUploader, ImageViewer } from 'antd-mobile'
import { MailOutline } from 'antd-mobile-icons'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import MHead from '../../components/MHead/index'
import jiasupinchengPng from '../../static/YearMiddleReport2024/Cheats/jiasupincheng.png'
import wenhaoPng from '../../static/YearMiddleReport2024/detail/wenhao.png'
import mianpinPng from '../../static/YearMiddleReport2024/detail/mianpin.png'
import tipsPng from '../../static/YearMiddleReport2024/Cheats/tips.png'
import demo1Png from '../../static/YearMiddleReport2024/Cheats/demo1.png'
import demo2Png from '../../static/YearMiddleReport2024/Cheats/demo2.png'
import { useImmer } from 'use-immer'
import { getTeamWorkDetailApi, regionOssPolicy, submitFastTeamApi } from '../../api/yearEndReportApi'

let Index = () => {
  // document.title = '分享/付费'
  document.title = '加速成团秘籍'
  const [userInfo, setUserInfo] = useImmer(JSON.parse(sessionStorage.getItem('userInfo') || '{}'))

  const { id: clusterId } = useParams()

  let navigate = useNavigate()

  useEffect(() => {
    if (clusterId) {
      getTeamWorkDetail()
    }
  }, [clusterId])

  const [users, setUsers] = useState([])
  const getTeamWorkDetail = async () => {
    try {
      let { data } = await getTeamWorkDetailApi({
        clusterId,
        openId: userInfo.openId
      })
      data.users[2] = {
        isFree: true
      }
      setUsers(data.users)
      if (data.url) {
        setFileList([{ url: data.url }])
      }

    } catch (error) {
      console.log(error)
    } finally {
    }
  }



  const [fileList, setFileList] = useState([])
  console.log(fileList)

  const uploadHandle = async (file) => {
    // try {
    let res = await regionOssPolicy({
      'openId': userInfo.openId,
      folder: `report-h5`,
    })
    console.log(res)
    let formData = new FormData();
    console.log(formData)
    let filename = file.name.substring(0, file.name.lastIndexOf('.'));
    console.log(filename)
    const suffix = file.name.slice(file.name.lastIndexOf('.'));
    console.log(suffix)
    filename = new Date().getTime() + suffix;
    console.log(filename)
    const key = res.data.dir + '/' + filename;
    console.log(key)
    formData.append('key', key);
    formData.append('file', file);
    formData.append('policy', res.data.policy);
    formData.append('OSSAccessKeyId', res.data.accessid);
    formData.append('Signature', res.data.signature);
    formData.append('success_action_status', 200);

    console.log(formData)

    let response = await fetch(res.data.host, {
      method: "POST",
      body: formData
    })

    console.log(response)

    let url = response.url + key + '?x-oss-process=style/Image_original'


    console.log(url)
    let res1 = await submitFastTeamApi({
      openId: userInfo.openId,
      clusterId,
      url
    })

    console.log(res1)
    if (res1.status === 200) {
      Toast.show('上传成功,等待后台人员审核~')
    } else {
      Toast.show(res1.msg)
    }
    return {
      url
    }
    // } catch (error) {
    //   console.log('啥报错呢', error)
    //   Toast.show('上传失败')
    //   return Promise.reject()
    // }
  }

  const [visibleTip1, setVisibleTip1] = useState(false)
  const [visibleTip2, setVisibleTip2] = useState(false)
  return (

    <div className="Cheats page">
      <MHead />
      <div className="pageContent">
        <img src={jiasupinchengPng} className='bg' alt='jiasupinchengPng' />

        <div className='pageContentOver'>
          <div className='pageContentOverTitle'>
            <h6>上传截图</h6>
            <p>任意完成秘籍一或二的任务，并上传截图。</p>
          </div>

          <div className='pageContentOverBtn'>
            <div onClick={() => {
              setVisibleTip1(true)
            }}>查看秘籍一任务示例图</div>
            <div onClick={() => {
              setVisibleTip2(true)
            }}>查看秘籍二任务示例图</div>
          </div>
          <div className='pageContentOverUpload'>
            <div className='pageContentOverUploadWrap'>
              {
                fileList.length === 0 && <span>点击加号上传截图</span>
              }

              <ImageUploader
                value={fileList}
                onChange={setFileList}
                upload={uploadHandle}
                maxCount={1}
                showFailed={false}
              />
            </div>
            <div className='pageContentOverteam'>
              <Image
                src={tipsPng}
                width={171}
                height={52}
                fit="cover"
                className='image'
              />

              <div className='groupDetailPerson'>
                {
                  users?.map((item, index) => {
                    return <div key={index}>
                      {
                        item ? <>
                          {
                            item.isFree ?
                              <Image
                                src={mianpinPng}
                                width={43}
                                height={43}
                                fit="cover"
                                className='image'
                              /> :
                              <>
                                <Image
                                  src={item.headImgUrl}
                                  width={43}
                                  height={43}
                                  fit="cover"
                                  className='image'
                                  style={{ borderRadius: 21 }}
                                />
                                {
                                  item.isLeader && <span>团长</span>
                                }
                              </>
                          }
                        </> :
                          <Image
                            src={wenhaoPng}
                            width={43}
                            height={43}
                            fit="cover"
                            className='image'
                          />
                      }
                    </div>
                  })
                }
              </div>
            </div>

          </div>


        </div>

      </div>
      <ImageViewer
        classNames={{
          mask: 'customize-mask',
          body: 'customize-body',
        }}
        image={demo1Png}
        visible={visibleTip1}
        onClose={() => {
          setVisibleTip1(false)
        }}
      />
      <ImageViewer
        classNames={{
          mask: 'customize-mask',
          body: 'customize-body',
        }}
        image={demo2Png}
        visible={visibleTip2}
        onClose={() => {
          setVisibleTip2(false)
        }}
      />
    </div >
  )
}

export default Index
